"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_L1_NODES = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_L1_NODES = (0, gql_1.gql)(`
  query HLQATasksL1Nodes(
    $productTreeId: ID!
  ) {
    productTreeNode(id: $productTreeId) {
      children {
        id
        title
      }
    }
  }
`);
